














































import Proxyable from '@/mixins/proxyable';
import { IFormSection } from '@/models';
import { PropType } from 'vue';

import Draggable from 'vuedraggable';

export default Proxyable.extend({
  name: 'FormBuilderSectionToolbar',

  components: { Draggable },

  props: {
    sections: Array as PropType<IFormSection[]>,
    disabled: Boolean
  },

  computed: {
    localSections: {
      get(): IFormSection[] {
        return this.sections;
      },
      set(val: IFormSection[]) {
        this.$emit('update:sections', val);
      }
    }
  },

  methods: {
    addSection() {
      this.$emit('addSection');
    },

    reorderTemplateSections() {
      this.$emit('reorderTemplateSections');
    }
  }
});
